import { render, staticRenderFns } from "./AddVisitTypeGroup.vue?vue&type=template&id=8c90b00c&scoped=true&"
import script from "./AddVisitTypeGroup.vue?vue&type=script&lang=js&"
export * from "./AddVisitTypeGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c90b00c",
  null
  
)

export default component.exports